import { createContext, useContext, useMemo, useState } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { useQueryOtherInfos } from 'hb-react/shared/hooks/useQueryOtherInfos';

const JobContext = createContext();

export const JobContextProvider = ({ job, children }) => {
  const { currentUser } = useDefaultAppContexts();

  const jobKindConfigs = useQueryOtherInfos({
    getter: (data) => data?.job_kind_configurations,
  });

  const jobKindConfig = useMemo(
    () => jobKindConfigs.find((config) => config.kind_id === job?.kind_id),
    [job?.kind_id, jobKindConfigs],
  );

  const locale = currentUser?.locale || I18n.locale;
  const jobKindName = jobKindConfig?.names[locale];

  const [hasCurrentUserAlreadyApplied, setHasCurrentUserAlreadyApplied] =
    useState(job?.current_user_has_already_applied);

  const value = useMemo(
    () => ({
      ...job,
      jobKindConfig,
      jobKindName,
      hasCurrentUserAlreadyApplied,
      setHasCurrentUserAlreadyApplied,
    }),
    [
      job,
      jobKindConfig,
      jobKindName,
      hasCurrentUserAlreadyApplied,
      setHasCurrentUserAlreadyApplied,
    ],
  );

  return <JobContext.Provider value={value}>{children}</JobContext.Provider>;
};

export const useJobContext = () => useContext(JobContext);

export default JobContext;
